import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import * as styles from '../../../styles/layout/care-image-text.module.scss';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PolyLink from '../PolyLink';

const ImageText = ({ item }) => {
  const {
    title,
    text,
    media,
    iconUrl,
    subtitle,
    link,
    action_new_page,
    aria_label,
    isInCarousel = false,
    is_reversed = false
  } = item;
  const buttonTarget = action_new_page ? '_blank' : '_self';
  const renderButton = () => {
    if (!subtitle || !link) return null;

    return (
      <div
        className="linkBox"
      >
        <PolyLink
          aria-label={aria_label}
          className="linkBox-title"
          style={{
            backgroundColor: 'var(--secondary-color)'
          }}
          target={buttonTarget}
          url={link}
        >
          <p className={styles.buttonText}>{subtitle}</p>
        </PolyLink>
      </div>
    );
  };

  return (
    <div className={clsx(
      styles.careImageTextContainer,
      {
        [styles.inCarousel]: isInCarousel,
        [styles.reversed]: is_reversed
      }
    )}
    >
      <div className={styles.contentContainer}>
        {iconUrl && (
          <div className={styles.iconContainer}>
            <img alt="Icône"
              className={styles.icon}
              src={iconUrl}
            />
          </div>
        )}
        {title && <h4 className={styles.title}>{title}</h4>}
        {text && <p className={styles.text}>{text}</p>}
        <div className={styles.desktopButton}>
          {renderButton()}
        </div>
      </div>
      <div className={styles.imageContainer}>
        {media?.imageFile && (
          <GatsbyImage
            alt={''}
            className={styles.image}
            image={getImage(media?.imageFile)}
            loading="eager"
            style={{height: '100%', width: 'inherit'}}
          />
        )}
      </div>
      {isInCarousel && (
        <div className={styles.mobileButton}>
          {renderButton()}
        </div>
      )}
    </div>
  );
};

ImageText.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.string,
    media: PropTypes.shape({
      imageFile: PropTypes.object
    }),
    iconUrl: PropTypes.string,
    subtitle: PropTypes.string,
    link: PropTypes.string,
    action_new_page: PropTypes.bool,
    aria_label: PropTypes.string,
    isInCarousel: PropTypes.bool,
    is_reversed: PropTypes.bool
  }).isRequired
};

export default ImageText;